import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { align: "center" }
const _hoisted_2 = { class: "mt-4" }
const _hoisted_3 = { class: "text-subtitle-1 text-medium-emphasis" }
const _hoisted_4 = { class: "text-subtitle-1 text-medium-emphasis d-flex align-center justify-space-between" }
const _hoisted_5 = { class: "text-subtitle-1 text-medium-emphasis d-flex align-center justify-space-between" }

import DoctorHeader from '@/components/Doctors/Headers/DoctorHeader.vue'
import FooterComponent from '@/components/Footer/FooterComponent.vue'
import { useUserActions } from '@/stores/user-actions'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useMeta } from 'vue-meta'
import { useToast } from 'vue-toast-notification'


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactDoctorComponent',
  setup(__props) {

const { t } = useI18n()

const name = ref<string | null>(null)
const email = ref<string | null>(null)
const message = ref<string | null>(null)
const isLoading = ref<boolean>(false)
const responseStatus = ref({})
const $toast = useToast()
const keyValue = ref(0)
const emailRules = [
  (v: string) => !!v || t('email-required'),
  (v: string) => /.+@.+\..+/.test(v) || t('email-authentic'),
]
const nameRule = [(v: string) => !!v || t('name-required')]
const messageRule = [(v: string) => !!v || t('message-required')]

const isInfoCompleted = computed(() => {
  const isEmailInvalid = emailRules.some((rule) => {
    const result = rule(email.value ?? '')
    return typeof result === 'string'
  })
  const isNameValid = nameRule.some((rule) => {
    const result = rule(name.value ?? '')
    return typeof result === 'string'
  })
  const isMessageValid = messageRule.some((rule) => {
    const result = rule(message.value ?? '')
    return typeof result === 'string'
  })

  return !isEmailInvalid && !isNameValid && !isMessageValid
})

useMeta(
  computed(() => ({
    title: t('meta.contact'),
  }))
)

const submit = async () => {
  isLoading.value = true
  const userAction = useUserActions()

  const data = {
    email: email.value ?? '',
    name: name.value ?? '',
    message: message.value ?? '',
  }

  const response = await userAction.contactMedCircle(data)
  responseStatus.value = response
  if (response.success) {
    $toast.success(t('successfully-message-sent'), {
      position: 'top-right',
    })
  } else {
    $toast.error(t('successfully-not-message-sent'), {
      position: 'top-right',
    })
  }
  email.value = null
  name.value = null
  message.value = null
  isLoading.value = false
  keyValue.value++
}

return (_ctx: any,_cache: any) => {
  const _component_request_status = _resolveComponent("request-status")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", { key: keyValue.value }, [
    _createVNode(DoctorHeader),
    _createVNode(_component_request_status, {
      response: responseStatus.value,
      isLoading: isLoading.value
    }, null, 8, ["response", "isLoading"]),
    _createElementVNode("div", null, [
      _createVNode(_component_v_card, {
        class: "mx-auto pa-12 pb-8 my-15",
        elevation: "8",
        "max-width": "448",
        rounded: "lg"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_img, {
              width: "100px",
              src: require('../../../assets/support.png')
            }, null, 8, ["src"])
          ]),
          _createVNode(_component_v_alert, {
            class: "mt-5",
            density: "compact",
            text: _ctx.$t('contact-us-line'),
            title: _ctx.$t('contact-us'),
            type: "info"
          }, null, 8, ["text", "title"]),
          _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t('contact-form')), 1),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('name')), 1),
          _createVNode(_component_v_text_field, {
            modelValue: name.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
            density: "compact",
            placeholder: _ctx.$t('name'),
            "prepend-inner-icon": "mdi-pencil",
            rules: nameRule,
            variant: "outlined"
          }, null, 8, ["modelValue", "placeholder"]),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('email')), 1),
          _createVNode(_component_v_text_field, {
            modelValue: email.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((email).value = $event)),
            density: "compact",
            placeholder: _ctx.$t('email'),
            "prepend-inner-icon": "mdi-email-outline",
            rules: emailRules,
            variant: "outlined"
          }, null, 8, ["modelValue", "placeholder"]),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('message')), 1),
          _createVNode(_component_v_textarea, {
            modelValue: message.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((message).value = $event)),
            density: "compact",
            placeholder: _ctx.$t('message'),
            "prepend-inner-icon": "mdi-pencil",
            rules: messageRule,
            variant: "outlined"
          }, null, 8, ["modelValue", "placeholder"]),
          _createVNode(_component_v_btn, {
            class: "mb-8",
            color: "blue",
            size: "large",
            variant: "flat",
            block: "",
            loading: isLoading.value,
            disabled: !isInfoCompleted.value,
            onClick: submit
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('send')), 1)
            ]),
            _: 1
          }, 8, ["loading", "disabled"])
        ]),
        _: 1
      })
    ]),
    _createVNode(FooterComponent)
  ]))
}
}

})